import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import type { RequestGetStudentChallenges } from "@/entities/student-challenge/domain/repository";
import type { GetStudentChallengesResponseDto } from "@/entities/student-challenge/domain/dtos";
import { StudentChallengeRepository } from "@/entities/student-challenge/domain/repository";

@singleton()
export default class StudentChallengesRepositoryImpl implements StudentChallengeRepository {
    constructor(@inject("HttpAdapter") private readonly server: HttpAdapter) {}

    getStudentChallenges = async (request: RequestGetStudentChallenges) => {
        let url = `/v1/academies/${request.academyId}/student-challenges?`;

        url += `challengeTemplateId=${request.challengeTemplateId}&`;

        if ("fromAssignedCount" in request) {
            url += `fromAssignedCount=${request.fromAssignedCount}&`;
        }

        if ("toAssignedCount" in request) {
            url += `toAssignedCount=${request.toAssignedCount}&`;
        }

        if (request.keyword) {
            url += `keyword=${request.keyword}&`;
        }

        if (request.size) {
            url += `size=${request.size}&`;
        }

        if (request.nextToken) {
            url += `nextToken=${request.nextToken}`;
        }

        const response = await this.server.get<GetStudentChallengesResponseDto>(url);

        return response;
    };
}
